import { Button, ButtonGroup, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export function InvoiceLinks() {
    const navigate = useNavigate();

    return (
        <Card className="bg-primary text-white flex-fill">
            <Card.Header>Links</Card.Header>
            <Card.Body className="bg-canvas">
                <ButtonGroup vertical style={{ backgroundColor: "var(--bs-white)" }}>
                    <Button variant="outline-primary" onClick={() => navigate("/invoice-reports")}>
                        Invoice Reports
                    </Button>
                </ButtonGroup>
            </Card.Body>
        </Card>
    );
}
